import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { isNil as _isNil } from 'lodash';
import { ExportPatternInfoResource } from '@blcloud/bl-ng-resource';
import { IExportPatternInfo, IPmExportPatternInfo } from '@blcloud/bl-datamodel';
import { BlApiSearchCondition, BlApiConditionHelper } from '@blcloud/bl-ng-common';
import { LogicalDeleteDiv } from '@blcloud/bl-datamodel/enum/common/logical-delete-div';

@Injectable()
export class ExportPatternModalService {
  constructor(
    private resource: ExportPatternInfoResource,
  ) {}

  /**
   * 出力並び順設定画面での入力項目情報と出力項目情報を取得する
   * [GET] /exportpatterninfo/all
   * @param exportPatternCode テキスト出力パターンコード 出力項目情報を取得するため
   * @return テキスト出力パターン情報
   */
  public getExportPatternInfo(
    exportPatternCode: string,
  ): Observable<IExportPatternInfo[]> {
    return this.resource
      .getAll<IExportPatternInfo>({ conditions: this.makeCondition(exportPatternCode) })
      .pipe(map((res) => (res && res.searchResultList ? res.searchResultList : [])));
  }

  /**
   * 出力パターン情報更新処理
   * @param id テキスト出力パターンコード
   * @param data 出力パターン情報
   */
  public updateExportPatternInfo(id: string, data: IExportPatternInfo): Observable<IPmExportPatternInfo> {
    return this.resource.putById<IPmExportPatternInfo>(id, data);
  }

  /**
   * 入力項目と出力項目を同時に取得するため、取得条件を編集する
   * @param exportPatternCode テキスト出力パターンコード　出力項目情報を取得するため
   * @return 検索条件
   */
  private makeCondition(exportPatternCode: string): BlApiSearchCondition {
    const condition = new BlApiSearchCondition();
    condition.addCondition(
      // 出力項目の取得条件
      BlApiConditionHelper.makeCondAnd(
        BlApiConditionHelper.makeCondStrEqual('exportPatternCode', exportPatternCode),
        BlApiConditionHelper.makeCondStrEqual('logicalDeleteDiv', LogicalDeleteDiv.Valid)
      )
    );
    return condition;
  }

  /**
   * 出力パターン情報取得処理（セッション）
   * @param dataExportPatterns テキスト出力パターン情報
   * @return 出力パターン情報
   */
  getExportPatternInfoFromSession(
    dataExportPatterns: IExportPatternInfo
  ): IExportPatternInfo[] | null {
    const result: IExportPatternInfo[] = [];
    if (_isNil(dataExportPatterns)) {
      return null;
    }
    result.push(dataExportPatterns);
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/export-modal/export-pattern-modal/export-pattern-modal.service.ts